<template>
  <div>
    <div class="right pd20">
      <vxe-table
        :data="knockInvs"
        :cell-style="cellStyle"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable mgb10"
        size="mini"
        resizable
        round
        auto-resize
        :span-method="mergeMethod"
        border
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          style="vertical-align: top"
          min-width="160px"
        >
          <template v-slot="{ row }">
            <div style="vertical-align: top">
              <div class="float-left mgr5">
                <thumbnail :images="row._images" />
              </div>
              <div class="float-left mgl5">
                {{ row._productNo }}
                <div>{{ $t("text.quantity") }}:{{ row._quantity }}</div>
              </div>
              <div class="clearfix">
                {{ row._serialNo }}
              </div>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        />
        <vxe-table-column
          field="color"
          :title="$t('product.color')"
          min-width="80"
        />
        <vxe-table-column
          field="size"
          :title="$t('product.size')"
          min-width="60"
        />

        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="60"
        />
        <vxe-table-column
          field="totalLock"
          :title="$t('inventory.totalLock')"
          min-width="80"
        />
        <vxe-table-column
          field="shopName"
          :title="$t('menu.warehouses')"
          min-width="60"
        />
        <vxe-table-column
          field="inventoryShelfs"
          :title="$t('inventory.quantity')"
          min-width="120"
        >
          <template v-slot="{ row }">
            <div
              v-for="(item, index) of row.inventoryShelfs"
              :key="index"
              class="font10"
            >
              {{ item.shelfName }}：{{ item.quantity }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="10"
              type="richText"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column field="action" :title="$t('text.action')" width="90">
          <template v-slot="{ row }">
            <template v-if="row.quantity - row.totalLock >= row._quantity">
              <el-button
                type="text"
                :loading="knockInvPreparedDoing"
                size="small"
                @click="knockInvPrepared(row)"
                >{{ $t("orderStates.prepared") }}</el-button
              >
              <div v-if="!Permit.isFreeEdition()">
                <el-dropdown v-if="Permit.extendModels().includes('mes')">
                  <el-button type="text" size="small">
                    {{ $t("dealTypes.manufacture") }}{{ $t("action.remake") }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="factory in factories"
                      :key="factory.id"
                    >
                      <div @click="remake(row, 'mes', factory)">
                        {{ factory.name }}
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <span v-else>
                  <el-button
                    type="text"
                    size="small"
                    @click="remake(row, 'noMes', factory)"
                  >
                    {{ $t("dealTypes.manufacture") }}{{ $t("action.remake") }}
                  </el-button>
                </span>
              </div>
            </template>
          </template>
        </vxe-table-column>
      </vxe-table>
      <el-button size="small" type="default" @click="close">
        {{ $t("text.close") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Thumbnail from "@/components/Thumbnail";
import Currency from "@/components/Currency";
import Order from "@/api/order.js";
import Factory from "@/api/factory.js";

export default {
  props: {
    orders: Array,
  },
  mixins: [page],
  components: {
    Thumbnail,
    Currency,
  },
  data() {
    return {
      //
      knockInvs: [],
      knockInvPreparedDoing: false,
      loading: false,
      //
      factories: [],
      submitDoing: false,
    };
  },
  watch: {
    orders() {
      this.getKnockInvs();
    },
  },
  created() {
    const self = this;
    self.getKnockInvs();
    if (self.Permit.extendModels().includes("mes")) {
      self.getFactories();
    }
  },
  methods: {
    remake(row, type, factory) {
      const self = this;
      let obj = {
        serialNo: row._serialNo,
        uuid: row._orderUuid,
        productNo: row._productNo,
        color: row.color,
        size: row.size,
        quantity: row._quantity,
        shopId: row.shopId,
        shopName: row.shopName,
        remark: null,
        disableStockOut: false,
        factoryId: type == "mes" ? factory.id : null, //生产
        factoryName: type == "mes" ? factory.name : null, //生产
        type: "manufacture",
        // supplierId: null, //外采
        // supplierName: null, //外采
        // supplierTenantId: null, //外采
        // handOverAt: null, //外采
        // hurry: null, //外采
        // price: null, //外采
      };
      self.submitDoing = true;
      Order.remake(obj).then(function (res) {
        self.submitDoing = false;
        self.remakeDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.dealSuccess"),
            type: "success",
          });
          self.$eventHub.$emit("orderRemakeManufacture");
          self.$emit("updateDataNoClose");
          self.getKnockInvsAgain(row._id);
        } else {
          self.sysError();
        }
      });
    },
    //
    getFactories() {
      const self = this;
      Factory.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.factories = res.data;
        } else {
          self.sysError();
        }
      });
    },

    getKnockInvs() {
      const self = this;
      self.loading = true;
      Order.knockInvByIds({ ids: self.orders.map((s) => s.id) }).then(function (
        res
      ) {
        self.loading = false;
        if (res.status == 200) {
          const knockInvs = res.data;
          const knockInvsFilter = knockInvs.filter((r) => r.invs.length != 0);
          for (let knockInv of knockInvsFilter) {
            Vue.set(
              knockInv,
              "order",
              self.orders.find((o) => o.id == knockInv.id)
            );
          }
          self.knockInvs = self.buildTableData(knockInvsFilter);
        } else {
          self.sysError();
        }
      });
    },
    buildTableData(records) {
      let rs = [];
      records.forEach((element) => {
        const invsFilter = element.invs.filter(
          (i) => i.quantity - i.totalLock >= element.order.quantity
        );
        invsFilter.forEach((inv) => {
          let obj = inv;
          Vue.set(obj, "_id", element.order.id);
          Vue.set(obj, "_serialNo", element.order.serialNo);
          Vue.set(obj, "_productNo", element.order.productNo);
          Vue.set(obj, "_quantity", element.order.quantity);
          Vue.set(obj, "_images", element.order.images);
          Vue.set(obj, "_orderUuid", element.order.uuid);
          Vue.set(obj, "_invs", invsFilter);
          rs.push(obj);
        });
      });
      return rs;
    },
    mergeMethod({ rowIndex, columnIndex }) {
      const mergeCells = this.buildMergeCells();
      for (let mIndex = 0; mIndex < mergeCells.length; mIndex++) {
        const { row, col, rowspan, colspan } = mergeCells[mIndex];
        if (row === rowIndex && col === columnIndex) {
          return { rowspan, colspan };
        }
        if (
          rowIndex >= row &&
          rowIndex < row + rowspan &&
          columnIndex >= col &&
          columnIndex < col + colspan
        ) {
          return { rowspan: 0, colspan: 0 };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },
    buildMergeCells() {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < this.knockInvs.length; i++) {
        mcs.push({
          row: rowIdx, //行
          col: 0,
          rowspan: this.knockInvs[i]._invs.length, //跨行
          colspan: 1, //跨列
        });
        rowIdx = rowIdx + this.knockInvs[i]._invs.length;
      }
      return mcs;
    },
    knockInvPrepared(row) {
      const self = this;
      const obj = {
        id: row._id,
        inventoryId: row.id,
      };
      self.knockInvPreparedDoing = true;
      Order.knockDeal(obj).then(function (res) {
        self.knockInvPreparedDoing = false;
        self.knockInvsDF = false;
        if (res.status === 200) {
          self.sysResult(res.data);
          self.$emit("updateDataNoClose");
          self.$eventHub.$emit("OrderKnockDeal");
          self.getKnockInvsAgain(row._id);
        } else {
          self.sysError();
        }
      });
    },
    getKnockInvsAgain(orderId) {
      const self = this;
      const orderIds = self.knockInvs.map((c) => c._id);
      const orderIdsSet = [...new Set(orderIds)];
      const orderIdsSetFilter = orderIdsSet.filter((o) => o != orderId);
      if (orderIdsSetFilter.length == 0) {
        self.$emit("updateData");
        return;
      }
      self.loading = true;
      Order.knockInvByIds({ ids: orderIdsSetFilter }).then(function (res) {
        self.loading = false;
        if (res.status == 200) {
          const knockInvs = res.data;
          const knockInvsFilter = knockInvs.filter((r) => r.invs.length != 0);
          for (let knockInv of knockInvsFilter) {
            Vue.set(
              knockInv,
              "order",
              self.orders.find((o) => o.id == knockInv.id)
            );
          }
          self.knockInvs = self.buildTableData(knockInvsFilter);
        } else {
          self.sysError();
        }
      });
    },
    close() {
      this.$emit("close");
    },
    cellStyle({ row, rowIndex, column, columnIndex }) {
      if (columnIndex == 0) {
        return {
          "vertical-align": "top",
        };
      }
      return "";
    },
  },
};
</script>
